// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3yE8u","footer":"ModalUpdate_footer__3Dyw6"};